<template>
  <TContentFigure
    :desktop-figure-rigth="true"
    :desktop-items-center="true"
    :classes="'pt-6 pb-12 lg:py-12'"
  >
    <template #figure>
      <div v-if="youtubeUrl || image">
        <TLazyimg
          v-if="image"
          :src="image"
          classes="block w-full h-full aspect-w-3 aspect-h-2"
          classes-img="block w-full h-full rounded-xl"
          alt=""
        />
        <div
          v-if="!image && youtubeUrl"
          class="flex justify-center aspect-w-3 aspect-h-2"
        >
          <iframe
            :title="title"
            width="100%"
            height="100%"
            :src="youtubeUrl"
            loading="lazy"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          />
        </div>
      </div>
    </template>
    <template #content>
      <TTitle tag="h2" size="xs">
        {{ title }}
      </TTitle>
      <TText size="lg" tag="h3" variant="semibold" classes="mb-0">
        {{ subtitle }}</TText
      >
      <TText classes="mb-0"> {{ text }}</TText>
      <UButton
        variant="solid"
        size="lg"
        :block="isMobile"
        :label="button.text"
        :to="button.url ? button.url : undefined"
        target="_blank"
        external
        class="mt-8"
        @click="emit('media-banner-click', $event)"
      />
    </template>
  </TContentFigure>
</template>

<script setup lang="ts">
export interface propsInterface {
  title: string
  subtitle: string
  text: string
  button: {
    text: string
    url: string | null
  }
  image?: string | null
  youtubeUrl?: string | null
}
defineProps<propsInterface>()

const { isMobile } = useDevice()

const emit = defineEmits(['media-banner-click'])
</script>
